import type { OptimisationBarLayoutDto } from '@cutlyft/zod-schemas';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

interface CutTableProps {
  barLayout: OptimisationBarLayoutDto;
}

export function CutTable({ barLayout }: CutTableProps) {
  const { cuts, wasteMm, offcutReturnedMm } = barLayout;

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-12">#</TableHead>
          <TableHead>Component</TableHead>
          <TableHead>Line Item</TableHead>
          <TableHead className="text-right">Length</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {cuts.map((cut) => (
          <TableRow key={cut.id}>
            <TableCell className="font-mono text-xs">{cut.cutIndex + 1}</TableCell>
            <TableCell>
              <Badge variant="outline" className="text-xs">
                {cut.component}
              </Badge>
            </TableCell>
            <TableCell className="text-fg-muted text-xs">#{cut.sourceLineItemId}</TableCell>
            <TableCell className="text-right font-mono text-xs">{cut.lengthMm} mm</TableCell>
          </TableRow>
        ))}
        {offcutReturnedMm > 0 && (
          <TableRow className="text-fg-muted">
            <TableCell />
            <TableCell colSpan={2} className="text-xs italic">Offcut returned</TableCell>
            <TableCell className="text-right font-mono text-xs">{offcutReturnedMm} mm</TableCell>
          </TableRow>
        )}
        <TableRow className="text-fg-muted">
          <TableCell />
          <TableCell colSpan={2} className="text-xs italic">Waste</TableCell>
          <TableCell className="text-right font-mono text-xs text-destructive">
            {wasteMm} mm
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
